import { render } from "./CreatePrescripcionDispositivos.vue?vue&type=template&id=e35ffb88&scoped=true"
import script from "./CreatePrescripcionDispositivos.vue?vue&type=script&lang=js"
export * from "./CreatePrescripcionDispositivos.vue?vue&type=script&lang=js"

import "./CreatePrescripcionDispositivos.vue?vue&type=style&index=0&id=e35ffb88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e35ffb88"]])

export default __exports__